import React from 'react'
import Dashboard from '../Features/Dashboard';
import ProjectManagement from '../Features/ProjectManagement';
import UserManagement from '../Features/UserManagement';
import { Route, Routes } from 'react-router-dom';
import SwaggerDocs from '../../SwaggerDocs';

const Body = () => {
  return (
    <div className='feature-content h-100'>
        <Routes>
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="manageProject" element={<ProjectManagement />} />
          <Route path="manageUsers" element={<UserManagement />} />
          <Route path="/api-docs" element={<SwaggerDocs />} />
        </Routes>
    </div>
  )
}

export default Body